import { computed } from 'vue'
import { useStore } from 'vuex'

function mapMenuLink(item, fallbackIcon = null) {
  return {
    key: item.key || item.path || item.name,
    name: item.name,
    path: item.path,
    active: item.active,
    icon: item.icon || fallbackIcon,
    method: item.method || 'GET',
    external: item.external,
    target: item.target,
    headers: item.headers,
    data: item.data,
  }
}

function flattenMenuItems(items = [], fallbackIcon = null) {
  const result = []

  for (const item of items) {
    const itemIcon = item.icon || fallbackIcon

    if (item.path) {
      result.push(mapMenuLink(item, itemIcon))
      continue
    }

    if (item.items?.length) {
      result.push(...flattenMenuItems(item.items, item.icon || fallbackIcon))
    }
  }

  return result
}

function mapSectionToNavItem(section) {
  const sectionIcon = section.icon || null
  const nestedItems = flattenMenuItems(section.items ?? [], sectionIcon)

  if (nestedItems.length > 0 && !section.path) {
    return {
      type: 'menu',
      key: section.key || section.name,
      name: section.name,
      icon: section.icon,
      active: Boolean(section.active || nestedItems.some(item => item.active)),
      items: nestedItems,
    }
  }

  if (section.path) {
    return {
      type: 'link',
      key: section.key || section.path || section.name,
      name: section.name,
      path: section.path,
      active: section.active,
      icon: section.icon,
      method: section.method || 'GET',
      external: section.external,
      target: section.target,
      headers: section.headers,
      data: section.data,
    }
  }

  if (nestedItems.length === 1) {
    return {
      type: 'link',
      ...nestedItems[0],
      key: section.key || nestedItems[0].key,
      name: section.name || nestedItems[0].name,
      icon: section.icon || nestedItems[0].icon,
    }
  }

  return null
}

export function useTopNavItems(primaryLimit = null) {
  const store = useStore()

  const allNavItems = computed(() => {
    const menu = store.getters.mainMenu ?? []

    return menu.map(mapSectionToNavItem).filter(Boolean)
  })

  const primaryNavItems = computed(() => {
    if (primaryLimit === null) {
      return allNavItems.value
    }

    return allNavItems.value.slice(0, primaryLimit)
  })

  const menuNavItems = computed(() => {
    if (primaryLimit === null) {
      return []
    }

    return allNavItems.value.slice(primaryLimit)
  })

  return {
    allNavItems,
    primaryNavItems,
    menuNavItems,
  }
}
